/**
 * Ensure some object is a coerced to a string
 **/
module.exports = function makeString(object) {
  if (object == null) return '';
  return '' + object;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/underscore.string/helper/makeString.js
// module id = rUx6
// module chunks = 0